export enum DamageState {
    Dead = 1,
    DamagedAndEuthanized = 2,
    DamagedNotEuthanized = 3,
    Missing = 4,
}